import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { autocompleteSearch } from "@insite/client-framework/Services/AutocompleteService";
import { chain, RequestDataFromApi } from "@NA/Overrides/Store/CommonHandlers/GetAutocompleteModel";

replaceInChain(chain, RequestDataFromApi, async props => {
    if (props.apiParameter.query.length >= 2) {
        props.apiResult = await autocompleteSearch(props.apiParameter);
    }
});
